import React, { useState, useEffect, useContext } from "react";
import { Form, Button } from "react-bootstrap";
import { GlobalContext } from "../../Context/GlobalState";
import {
  BASE_URL_API_TRANXT,
  BASE_URL_API_TRANXT_API,
  BASE_URL_API,
  BASE_URL_APISERVICES
} from "../../utils/Constants";
import swal from "sweetalert";
import Select from "react-select";
import { getLatLong, getClientIP } from "../../utils/utilFuctions";
import { API_ENDPOINTS } from "../../utils/apiEndpoints";
import { adminAuth } from "../../config";


const AddFundsAdmin = () => {
  const [ttype, setTtype] = useState([
    { label: "Reverse Funds", value: "2" },
  ]);
  const [ttype2, setTtype2] = useState([
    { label: "Add Lean", value: "1" },
    { label: "Remove Lean", value: "2" },
  ]);
  const [state, setState] = useState({
    userCode: "",
    utrNo: "",
    amount: "",
    amount2: "",
    bank: null,
    date: "",
    paymode: "",
    ttype: "",
    ttype2: "",
    remaks: "",
    remaks2: "",
  });
  const [userInfo, setUserInfo] = useState(null);
  const [wallet, setWallet] = useState({});
  const [pageAccess, setPageAccess] = useState({});
  const { user, setTransactionLoaderState } = useContext(GlobalContext);
  const [buttonShow, setButtonShow] = useState({
    reverseFundBtn: false,
    lean: false,
  });
  const { username1, password1 } = adminAuth;

  const twoDecimalPlaces = (value) => {
    return Number(value).toFixed(2).toString();
  };

  const searchUser = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        UserID: state.userCode,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.CREATE_LOAD_REQUEST}`,

        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        setUserInfo(data.data);
      } else {
        swal(
          "User Not Found",
          "Please Enter Valid ID Or Mobile number",
          "error"
        );
      }
      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      console.log("error", error);
    }
  };
  const clearData = () => {
    setState({
      ttype: "",
      amount: "",
      remaks: "",
    });
    setUserInfo(null);
  };

  const validateForm = () => {
    console.log(state);
    if (state.ttype == "") {
      swal("Invalid", "Please Enter Valid Type", "error");
      return;
    } else if (state.amount == "" || state.remarks == "") {
      swal("Invalid", "Fill All Mandatory Fields", "error");
      return;
    }
    addFunds();
  };

  const addFunds = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );
      myHeaders.append("Content-Type", "application/json");

      var raw = JSON.stringify({
        userid: userInfo.us_code,
        adminid: user.pkid,
        type: state.ttype.value,
        amount: state.amount,
        remaks: state.remaks,
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.REVERSE_FUND}`,
        requestOptions
      );
      const data = await res.json();
      if (data.status == "0") {
        swal("Success", data.msg, "success");
        searchUser();
      } else {
        swal("Failed", data.msg, "error");
      }

      setTransactionLoaderState(false);
    } catch (error) {
      setTransactionLoaderState(false);
      swal("Failed", "Something Went Wrong", "error");
      console.log("error", error);
    }
  };

  const leanAmount = async () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
    );
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "userid": userInfo.us_code,
      "adminId": user.pkid,
      "amount": state.amount2,
      "remark": state.remaks2,
      "type": state.ttype2.value,
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    try {
      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_LEAN_AMOUNT}`,
        requestOptions);

      const data = await res.json();
      if (data.responseCode == "00") {
        swal("Success", data.responseMessage, "success");
        getWalletInfo();
      } else {
        swal("Failed", data.responseMessage, "error");
      }
    } catch (error) {

    }


  }

  const getWalletInfo = async () => {
    var myHeaders = new Headers();
    myHeaders.append(
      "Authorization",
      "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
    );
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      "userid": state.userCode,
    });

    var requestOptions = {
      method: 'POST',
      headers: myHeaders,
      body: raw,
      redirect: 'follow'
    };

    try {
      const res = await fetch(
        `${BASE_URL_APISERVICES}${API_ENDPOINTS.GET_WALLET_BAL}`, requestOptions);

      const data = await res.json();
      if (data.status == "0") {
        setWallet(data.data);
      } else {
        swal("Failed", data.msg, "error");
      }
    } catch (error) {

    }


  }

  const getPageAccess = (menuId) => {
    const sub_menus_access_info = JSON.parse(sessionStorage.getItem("sub_menus"));
    sub_menus_access_info.forEach((acc) => {
      if (acc.pk_menu_id == menuId) {
        setPageAccess(acc);

      }
    })
  }

  const get_admin_access_info = async () => {
    try {
      setTransactionLoaderState(true);
      var myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");
      myHeaders.append(
        "Authorization",
        "Basic " + Buffer.from(username1 + ":" + password1).toString("base64")
      );

      let coords = await getLatLong();
      const ip = await getClientIP();

      var raw = JSON.stringify({
        userid: user.pkid,
        lattitude: coords[0],
        longitude: coords[1],
        ip: ip,
        pagename: "ADD_FUND"
      });

      var requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
      };

      const res = await fetch(
        `${BASE_URL_API}${API_ENDPOINTS.get_admin_access_info}`,
        requestOptions
      )
        .then((response) => response.json())
        .then((result) => {
          if (result.status == "0") {
            const reverseFund = result.services.find(
              (service) => service.pk_menu_id === "3"
            )

            const leanFund = result.services.find(
              (service) => service.pk_menu_id === "4"
            );
            setButtonShow({
              reverseFundBtn: reverseFund && reverseFund.status === "Y",
              lean: leanFund && leanFund.status === "Y",

            });

            setTransactionLoaderState(false);
          } else {
            setButtonShow({
              reverseFundBtn: false,
              lean: false,
            });
            setTransactionLoaderState(false);
          }
        })
        .catch((error) => console.log("error", error));

    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    getPageAccess(7);
    get_admin_access_info();
  }, [])

  console.log(wallet);
  //security functions
  useEffect(() => {
    const threshold = 150;

    const detectDevTools = () => {
      const isOpen =
        window.outerWidth - window.innerWidth > threshold ||
        window.outerHeight - window.innerHeight > threshold;

      const ui = document.getElementById("secure-ui");

      if (ui) {
        if (isOpen) {
          ui.style.filter = "blur(8px)";
          ui.style.pointerEvents = "none";
          ui.style.userSelect = "none";
        } else {
          ui.style.filter = "none";
          ui.style.pointerEvents = "auto";
          ui.style.userSelect = "auto";
        }
      }
    };

    const interval = setInterval(detectDevTools, 500);
    return () => clearInterval(interval);
  }, []);


  document.addEventListener('contextmenu', e => e.preventDefault());
  document.addEventListener('keydown', e => {
    if (
      e.key === "F12" ||
      (e.ctrlKey && e.shiftKey && (e.key === "I" || e.key === "J" || e.key === "C")) ||
      (e.ctrlKey && e.key === "u")
    ) {
      e.preventDefault();
      return false;
    }
  });
  //
  return (
    <GlobalContext.Consumer>
      {(context) => (


        <div id="secure-ui" className="p-4" style={{ backgroundColor: "#f4f7fe", minHeight: "100vh" }}>
          <div
            className="card border-0 shadow-sm mx-auto"
            style={{ borderRadius: "16px", maxWidth: "full", overflow: "hidden" }}
          >

            <div
              className="px-4 py-3 d-flex align-items-center justify-content-between"
              style={{ color: "#000" }}
            >
              <h5
                className="m-0 d-flex align-items-center"
                style={{
                  fontSize: "24px",
                  fontWeight: "700",
                  letterSpacing: "-0.5px",
                  color: "#121417",

                }}
              >
                <i
                  className="fas fa-wallet mr-3"
                  style={{
                    fontSize: "22px",
                    opacity: "0.9",
                    verticalAlign: "middle"
                  }}
                ></i>
                <span style={{ lineHeight: "1" }}>Add Fund</span>
              </h5>
            </div>

            <div className="card-body p-4">

              <div className="bg-light p-4 rounded mb-4   shadow-sm" style={{ borderLeftWidth: '4px !important' }}>
                <div className="row align-items-center">
                  <div className="col-md-6 col-lg-4">
                    <Form.Group className="mb-0">
                      <Form.Label className="font-weight-bold text-muted text-uppercase"
                        style={{ fontSize: "14px", letterSpacing: "0.5px", marginBottom: "8px", display: "block" }}>
                        User Search <span className="text-danger">*</span>
                      </Form.Label>
                      <div className="input-group ">
                        <Form.Control
                          type="text"
                          placeholder="User Code / Mobile Number"
                          value={state.userCode}
                          onChange={(e) => setState({ ...state, userCode: e.target.value })}
                          style={{ borderRadius: "8px 0 0 8px", border: "1px solid #ced4da" }}
                        />
                        <div className="input-group-append">
                          <Button
                            variant="primary"
                            onClick={() => { searchUser(); getWalletInfo(); }}
                            className="px-4"
                            style={{ borderRadius: "0 8px 8px 0" }}
                          >
                            Search
                          </Button>
                        </div>
                      </div>
                    </Form.Group>
                  </div>
                  <div className="col-md-2">
                    <Button variant="outline-secondary" block onClick={clearData} style={{ borderRadius: "8px" }}>
                      Clear
                    </Button>
                  </div>
                </div>
              </div>

              {userInfo && (
                <>

                  <div className="row mb-4">
                    {[
                      { label: "User Name", value: `${userInfo.us_name} [${userInfo.us_code}]`, color: "#6f42c1" },
                      { label: "Mobile No.", value: `${userInfo.us_loginid}`, color: "#007bff" },
                      { label: "Type", value: `${userInfo.usrtype}`, color: "#fd7e14" },
                      { label: "Current Balance", value: `₹${twoDecimalPlaces(userInfo.usrbal)}`, color: "#28a745" },
                      { label: "Loan Amount", value: `₹${twoDecimalPlaces(wallet.remaining_credit || 0)}`, color: "#ffc107" },
                      { label: "Lean Amount", value: `₹${twoDecimalPlaces(wallet.lean_amount || 0)}`, color: "#dc3545" }
                    ].map((item, idx) => (
                      <div className="col-lg-2 col-md-4 col-sm-6 mb-3 px-2" key={idx}>
                        <div className="p-3 shadow-sm border-0 h-100" style={{
                          backgroundColor: "#fff",
                          borderRadius: "10px",
                          borderLeft: `5px solid ${item.color}`,
                          minHeight: "85px"
                        }}>
                          <p
                            style={{
                              fontSize: "14px",
                              color: "#6c757d",

                            }}
                            className="small text-muted mb-1 text-uppercase font-weight-bold">{item.label}</p>
                          <h6 className="mb-0 font-weight-bolder" style={{
                            color: item.color,
                            fontSize: "16px",

                          }}>{item.value}</h6>
                        </div>
                      </div>
                    ))}
                  </div>

                  <div className="col mx-0">

                    <div className="col-lg-12 mb-4 px-0" >
                      <div className="h-100 p-4 border rounded shadow-sm bg-white" style={{ borderRadius: "12px", borderLeft: "5px solid #3676D8" }}>
                        <h6 className="font-weight-bold mb-4 text-primary" style={{ fontSize: "18px" }}>
                          Reverse Fund
                        </h6>

                        <div className="d-flex align-items-end flex-wrap" style={{ gap: "15px" }}>
                          <div style={{ flex: "2" }}>
                            <Form.Label className="font-weight-bold text-muted small text-uppercase">Type</Form.Label>
                            <Select
                              options={ttype}
                              value={state.ttype}
                              onChange={(e) => setState({ ...state, ttype: e })}
                              styles={{ control: (base) => ({ ...base, minHeight: '42px', borderRadius: '8px' }) }}
                            />
                          </div>

                          <div style={{ flex: "1.5" }}>
                            <Form.Label className="font-weight-bold text-muted small text-uppercase">Amount</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="0.00"
                              value={state.amount}
                              onChange={(e) => setState({ ...state, amount: e.target.value })}
                              style={{ borderRadius: "8px", height: "42px", fontSize: "16px", fontWeight: "600" }}
                            />
                          </div>

                          <div style={{ flex: "2" }}>
                            <Form.Label className="font-weight-bold text-muted small text-uppercase">Remarks</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Reason"
                              value={state.remaks}
                              onChange={(e) => setState({ ...state, remaks: e.target.value })}
                              style={{ borderRadius: "8px", height: "42px", fontSize: "16px" }}
                            />
                          </div>

                          <div style={{ flex: "1" }}>
                            <Button
                              disabled={!buttonShow?.reverseFundBtn}
                              variant="primary"
                              onClick={validateForm}
                              className="w-100 font-weight-bold shadow-sm"
                              style={{ borderRadius: "8px", height: "42px", fontSize: "15px", textTransform: "uppercase" }}
                            >
                              Submit
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>


                    <div className="col-lg-12 mb-4 px-0">
                      <div className="h-100 p-4 border rounded shadow-sm bg-white" style={{ borderRadius: "12px", borderLeft: "5px solid #dc3545" }}>
                        <h6 className="font-weight-bold mb-4 text-primary" style={{ fontSize: "18px" }}>
                          Lean Fund
                        </h6>

                        <div className="d-flex align-items-end flex-wrap" style={{ gap: "15px" }}>
                          <div style={{ flex: "2" }}>
                            <Form.Label className="font-weight-bold text-muted small text-uppercase">Lean Type</Form.Label>
                            <Select
                              options={ttype2}
                              value={state.ttype2}
                              onChange={(e) => setState({ ...state, ttype2: e })}
                              styles={{ control: (base) => ({ ...base, minHeight: '42px', borderRadius: '8px' }) }}
                            />
                          </div>

                          <div style={{ flex: "1.5" }}>
                            <Form.Label className="font-weight-bold text-muted small text-uppercase">Amount</Form.Label>
                            <Form.Control
                              type="number"
                              placeholder="0.00"
                              value={state.amount2}
                              onChange={(e) => setState({ ...state, amount2: e.target.value })}
                              style={{ borderRadius: "8px", height: "42px", fontSize: "16px", fontWeight: "600" }}
                            />
                          </div>

                          <div style={{ flex: "2" }}>
                            <Form.Label className="font-weight-bold text-muted small text-uppercase">Remarks</Form.Label>
                            <Form.Control
                              type="text"
                              placeholder="Reason"
                              value={state.remaks2}
                              onChange={(e) => setState({ ...state, remaks2: e.target.value })}
                              style={{ borderRadius: "8px", height: "42px", fontSize: "16px" }}
                            />
                          </div>

                          <div style={{ flex: "1" }}>
                            <Button
                              disabled={!buttonShow?.lean}
                              variant="primary"
                              onClick={leanAmount}
                              className="w-100 font-weight-bold shadow-sm"
                              style={{ borderRadius: "8px", height: "42px", fontSize: "15px", textTransform: "uppercase" }}
                            >
                              Submit
                            </Button>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </>
              )}
            </div>
          </div>
        </div>

      )}
    </GlobalContext.Consumer>
  );
};

export default AddFundsAdmin;